import * as React from "react";
import { UploadPermissionNotificationModel } from "@/views/drive/modals/uploadPermissionNotificationModal";
import { useGetFileDetailsQuery } from "@/api/files";

interface Props {
  fseId: string;
  handleClose: () => void;
}

export const UploadModalPermissionNotification: React.FC<Props> = ({ handleClose, fseId }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { data } = useGetFileDetailsQuery({ fse_id: fseId });

  React.useEffect(() => {
    if (data && data.owner_id !== "system") {
      // Show message for shared folder or file with multiple permissions
      if (data.access === "public" || data.permissions.length > 1) {
        setIsOpen(true);
      }
    }
  }, [data]);

  return isOpen ? <UploadPermissionNotificationModel handleClose={handleClose} /> : null;
};
